import { useParams, Link } from 'react-router-dom';
import {
  ArrowRight,
  ArrowLeft,
  Monitor,
  Shield,
  Server,
  Phone,
  FileText,
  HardDrive,
  Activity,
  Globe,
  Settings,
  CheckCircle,
  Users,
  Clock,
  Zap,
} from 'lucide-react';
import { Button } from '../components/ui/button';
import MICROSOFT_IMAGE from '../assets/images/Microsoft_365_Dgitaal.jpg';
import CYBER_SECURITY_IMAGE from '../assets/images/Dgitaal_hacked.jpg';
import TELEFONIE_IMAGE from '../assets/images/Dgitaal_VOIP.jpg';
import EFACTURATIE_IMAGE from '../assets/images/e-facturatie.png';


const servicesData = {
  microsoft365: {
    icon: Monitor,
    title: 'Microsoft 365',
    subtitle: 'Productiviteit verhogen met Microsoft 365',
    heroImage: MICROSOFT_IMAGE,
    description: `Microsoft 365 is de complete productiviteitssuite voor moderne bedrijven. 
    Met tools zoals Outlook, Teams, SharePoint en OneDrive werkt uw team efficiënter samen, 
    waar ze ook zijn. Wij helpen u bij de implementatie, migratie en het dagelijkse beheer 
    van uw Microsoft 365 omgeving.`,
    benefits: [
      'Overal toegang tot uw bestanden en e-mail',
      'Realtime samenwerking aan documenten',
      'Geïntegreerde communicatie met Teams',
      'Enterprise-grade beveiliging',
      'Automatische updates en nieuwe features',
    ],
    features: [
      {
        title: 'Exchange Online',
        description:
          "Professionele e-mail met 50GB mailbox, gedeelde agenda's en contacten.",
      },
      {
        title: 'Microsoft Teams',
        description:
          'Chat, videovergaderingen en samenwerking in één platform.',
      },
      {
        title: 'SharePoint & OneDrive',
        description:
          'Veilige opslag en delen van bestanden met 1TB per gebruiker.',
      },
      {
        title: 'Office Applicaties',
        description: 'Word, Excel, PowerPoint en Outlook op al uw apparaten.',
      },
    ],
    process: [
      'Assessment van huidige situatie',
      'Licentie advies en planning',
      'Migratie van e-mail en data',
      'Configuratie en security setup',
      'Training voor eindgebruikers',
      'Doorlopend beheer en support',
    ],
  },
  'managed-services': {
    icon: Settings,
    title: 'Managed Services',
    subtitle: 'Volledig IT-beheer uit handen',
    heroImage:
      'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200',
    description: `Met onze Managed Services neemt Dgitaal het volledige beheer van uw IT-infrastructuur 
    over. U kunt zich volledig focussen op uw kernactiviteiten terwijl wij zorgen voor een 
    stabiele, veilige en up-to-date IT-omgeving. Proactief onderhoud voorkomt problemen 
    voordat ze impact hebben op uw bedrijf.`,
    benefits: [
      'Voorspelbare maandelijkse kosten',
      'Proactief onderhoud en monitoring',
      'Snelle responstijd bij incidenten',
      'Toegang tot een team van experts',
      'Focus op uw kernactiviteiten',
    ],
    features: [
      {
        title: 'Helpdesk Support',
        description:
          'Eerstelijns support voor al uw medewerkers via telefoon, mail of portal.',
      },
      {
        title: 'Proactief Onderhoud',
        description:
          'Updates, patches en preventief onderhoud om problemen te voorkomen.',
      },
      {
        title: '24/7 Monitoring',
        description:
          'Continue monitoring van uw systemen met automatische alerts.',
      },
      {
        title: 'Vendor Management',
        description: 'Wij beheren het contact met uw IT-leveranciers.',
      },
    ],
    process: [
      'IT-assessment en inventarisatie',
      'Service Level Agreement opstellen',
      'Onboarding en documentatie',
      'Implementatie monitoring tools',
      'Proactief beheer starten',
      'Maandelijkse rapportages',
    ],
  },
  cybersecurity: {
    icon: Shield,
    title: 'Cybersecurity',
    subtitle: 'Bescherming tegen digitale dreigingen',
    heroImage: CYBER_SECURITY_IMAGE,
    description: `Cyberdreigingen worden steeds geavanceerder. Wij helpen uw bedrijf beschermen 
    tegen ransomware, phishing, datalekken en andere digitale gevaren. Van endpoint protection 
    tot security awareness training - wij bieden een complete aanpak voor uw digitale veiligheid.`,
    benefits: [
      'Bescherming tegen ransomware en malware',
      'Compliance met AVG/GDPR',
      'Verkleind risico op datalekken',
      'Bewustwording bij medewerkers',
      'Snelle detectie en respons',
    ],
    features: [
      {
        title: 'Endpoint Protection',
        description:
          'Geavanceerde bescherming voor al uw werkstations en servers.',
      },
      {
        title: 'Email Security',
        description: 'Bescherming tegen phishing, spam en malware via e-mail.',
      },
      {
        title: 'Security Awareness',
        description:
          'Training voor medewerkers om cyberdreigingen te herkennen.',
      },
      {
        title: 'Vulnerability Scanning',
        description:
          'Regelmatige scans om kwetsbaarheden in uw systemen te identificeren.',
      },
    ],
    process: [
      'Security assessment',
      'Risico-analyse en prioritering',
      'Implementatie security tools',
      'Configuratie en hardening',
      'Awareness training',
      'Continue monitoring en updates',
    ],
  },
  'it-beheer': {
    icon: Server,
    title: 'IT Beheer',
    subtitle: 'Professioneel beheer van uw infrastructuur',
    heroImage:
      'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200',
    description: `Uw IT-infrastructuur verdient professioneel beheer. Of het nu gaat om servers, 
    netwerken of werkplekken - wij zorgen ervoor dat alles optimaal functioneert. 
    Met proactief beheer voorkomen we problemen en zorgen we voor maximale uptime.`,
    benefits: [
      'Maximale uptime en beschikbaarheid',
      'Optimale prestaties van systemen',
      'Verlengde levensduur van hardware',
      'Professionele documentatie',
      'Strategisch IT-advies',
    ],
    features: [
      {
        title: 'Server Beheer',
        description:
          'Beheer van fysieke en virtuele servers, on-premise of in de cloud.',
      },
      {
        title: 'Netwerk Beheer',
        description: 'Configuratie en onderhoud van uw netwerk infrastructuur.',
      },
      {
        title: 'Werkplekbeheer',
        description: 'Beheer van laptops, desktops en mobiele apparaten.',
      },
      {
        title: 'Lifecycle Management',
        description: 'Planning en uitvoering van hardware vervanging.',
      },
    ],
    process: [
      'Inventarisatie huidige omgeving',
      'Documentatie en baseline',
      'Optimalisatie configuraties',
      'Implementatie beheertools',
      'Proactief onderhoud starten',
      'Periodieke reviews',
    ],
  },
  telefonie: {
    icon: Phone,
    title: 'Telefonie',
    subtitle: 'Moderne zakelijke communicatie',
    heroImage: TELEFONIE_IMAGE,
    description: `Moderne zakelijke telefonie gaat verder dan alleen bellen. Met Microsoft Teams 
    telefonie of een VoIP oplossing haalt u alle communicatie binnen één platform. 
    Bel, chat en vergader met klanten en collega's, waar u ook bent.`,
    benefits: [
      'Lagere telefoonkosten',
      'Overal bereikbaar op elk apparaat',
      'Integratie met Microsoft 365',
      'Professionele gespreksafhandeling',
      'Eenvoudig schaalbaar',
    ],
    features: [
      {
        title: 'Teams Telefonie',
        description:
          'Bellen via Microsoft Teams met uw eigen zakelijke nummer.',
      },
      {
        title: 'VoIP Centrales',
        description: 'Flexibele telefooncentrales in de cloud.',
      },
      {
        title: 'Call Recording',
        description: 'Opname van gesprekken voor training of compliance.',
      },
      {
        title: 'Auto Attendant',
        description: 'Professionele welkomstboodschap en doorschakeling.',
      },
    ],
    process: [
      'Analyse huidig telefoongebruik',
      'Nummerbehoud regelen',
      'Configuratie telefonie platform',
      'Uitrol naar gebruikers',
      'Training en documentatie',
      'Go-live en support',
    ],
  },
  'e-facturatie': {
    icon: FileText,
    title: 'E-facturatie',
    subtitle: 'Digitale facturatie conform wetgeving',
    heroImage: EFACTURATIE_IMAGE,
    description: `E-facturatie wordt steeds belangrijker, zeker voor bedrijven die zaken doen 
    met de overheid. Wij helpen u bij de implementatie van e-facturatie oplossingen 
    die voldoen aan alle Belgische en Europese regelgeving, zoals Peppol en UBL.`,
    benefits: [
      'Voldoen aan wettelijke vereisten',
      'Snellere verwerking van facturen',
      'Minder administratieve fouten',
      'Kostenbesparing op papier en porto',
      'Betere cashflow door snellere betaling',
    ],
    features: [
      {
        title: 'Peppol Integratie',
        description: 'Verstuur en ontvang facturen via het Peppol netwerk.',
      },
      {
        title: 'UBL Formaat',
        description:
          'Facturen in het juiste Universal Business Language formaat.',
      },
      {
        title: 'ERP Koppeling',
        description: 'Integratie met uw bestaande boekhoudsoftware.',
      },
      {
        title: 'Archivering',
        description: 'Digitale archivering conform wettelijke bewaartermijnen.',
      },
    ],
    process: [
      'Analyse huidig facturatieproces',
      'Selectie juiste oplossing',
      'Peppol registratie',
      'Integratie met boekhoudpakket',
      'Testen met klanten/leveranciers',
      'Training en go-live',
    ],
  },
  backups: {
    icon: HardDrive,
    title: 'Backup & Recovery',
    subtitle: 'Bescherm uw kritieke bedrijfsdata',
    heroImage:
      'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1200',
    description: `Data is het hart van uw bedrijf. Een goede backup strategie beschermt u 
    tegen dataverlies door hardware defecten, ransomware of menselijke fouten. 
    Wij zorgen voor betrouwbare backups en snelle recovery wanneer nodig.`,
    benefits: [
      'Bescherming tegen dataverlies',
      'Snelle recovery bij problemen',
      'Bescherming tegen ransomware',
      'Voldoen aan compliance eisen',
      'Gemoedsrust voor u en uw team',
    ],
    features: [
      {
        title: 'Cloud Backup',
        description: 'Veilige backup naar beveiligde datacenters in de EU.',
      },
      {
        title: 'Microsoft 365 Backup',
        description: 'Backup van uw e-mail, OneDrive en SharePoint data.',
      },
      {
        title: 'Disaster Recovery',
        description: 'Volledige herstel mogelijkheid bij calamiteiten.',
      },
      {
        title: 'Backup Monitoring',
        description: 'Dagelijkse controle of backups succesvol zijn.',
      },
    ],
    process: [
      'Inventarisatie kritieke data',
      'Bepalen RPO en RTO doelen',
      'Selectie backup oplossing',
      'Implementatie en configuratie',
      'Testen van restore procedure',
      'Monitoring en rapportage',
    ],
  },
  monitoring: {
    icon: Activity,
    title: 'Monitoring',
    subtitle: '24/7 inzicht in uw IT-omgeving',
    heroImage:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200',
    description: `Met proactieve monitoring zien we problemen aankomen voordat ze impact 
    hebben op uw bedrijf. Onze monitoring tools houden uw servers, netwerk en 
    applicaties 24/7 in de gaten en waarschuwen ons bij afwijkingen.`,
    benefits: [
      'Problemen oplossen voor impact',
      'Betere uptime en beschikbaarheid',
      'Inzicht in performance trends',
      'Snellere probleemoplossing',
      'Onderbouwde IT-beslissingen',
    ],
    features: [
      {
        title: 'Infrastructure Monitoring',
        description: 'Monitoring van servers, storage en netwerkapparatuur.',
      },
      {
        title: 'Application Monitoring',
        description: 'Beschikbaarheid en performance van uw applicaties.',
      },
      {
        title: 'Alerting',
        description: 'Automatische meldingen bij problemen of drempels.',
      },
      {
        title: 'Rapportages',
        description: 'Maandelijkse rapportages over beschikbaarheid en trends.',
      },
    ],
    process: [
      'Inventarisatie te monitoren systemen',
      'Bepalen KPIs en drempelwaarden',
      'Installatie monitoring agents',
      'Configuratie dashboards',
      'Instellen alerting',
      'Start 24/7 monitoring',
    ],
  },
  hosting: {
    icon: Globe,
    title: 'Hosting',
    subtitle: 'Betrouwbare hosting voor uw online aanwezigheid',
    heroImage:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200',
    description: `Of het nu gaat om een website, webshop of bedrijfsapplicatie - 
    betrouwbare hosting is essentieel. Wij bieden hosting oplossingen die 
    passen bij uw behoeften, van gedeelde hosting tot dedicated servers.`,
    benefits: [
      'Hoge beschikbaarheid en uptime',
      'Snelle laadtijden',
      'SSL certificaten inbegrepen',
      'Dagelijkse backups',
      'Technische support',
    ],
    features: [
      {
        title: 'Web Hosting',
        description: 'Hosting voor websites en webapplicaties.',
      },
      {
        title: 'Virtual Servers',
        description: 'VPS oplossingen met dedicated resources.',
      },
      {
        title: 'SSL Certificaten',
        description: 'Beveiligde verbindingen voor uw bezoekers.',
      },
      {
        title: 'Email Hosting',
        description: 'Professionele e-mail bij uw domeinnaam.',
      },
    ],
    process: [
      'Analyse hostingbehoefte',
      'Selectie juiste pakket',
      'Domein en DNS configuratie',
      'Website/applicatie migratie',
      'SSL en security setup',
      'Go-live en monitoring',
    ],
  },
};

export default function DienstDetail() {
  const { slug } = useParams();
  const service = servicesData[slug];

  if (!service) {
    return (
      <div className='pt-20 min-h-screen flex items-center justify-center admin-page'>
        <div className='text-center'>
          <h1 className='text-2xl font-bold text-[#16224b] mb-4'>
            Dienst niet gevonden
          </h1>
          <Link to='/diensten' className='text-[#3d56a6] hover:underline'>
            Terug naar diensten
          </Link>
        </div>
      </div>
    );
  }

  const Icon = service.icon;

  return (
    <div className='pt-20' data-testid={`dienst-detail-${slug}`}>
      <section
        className='relative overflow-hidden py-24 lg:py-28'
        style={{
          backgroundImage: `linear-gradient(rgba(22, 34, 75, 0.84), rgba(22, 34, 75, 0.9)), url(${service.heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className='absolute inset-0 dot-pattern opacity-60' />

        <div className='relative max-w-[1400px] mx-auto px-6 lg:px-10'>
          <Link
            to='/diensten'
            className='inline-flex items-center gap-2 text-white/70 hover:text-white mb-8 transition-colors'
            data-testid='back-to-diensten'>
            <ArrowLeft className='w-4 h-4' />
            Terug naar diensten
          </Link>

          <div className='max-w-3xl'>
            <div>
              <div className='flex items-center gap-4 mb-6'>
                <div className='w-16 h-16 rounded-full flex items-center justify-center bg-white/10 border border-white/15 text-white'>
                  <Icon className='w-8 h-8' />
                </div>
              </div>
              <h1 className='text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight'>
                {service.title}
              </h1>
              <p className='text-xl text-[#f8d45a] font-medium mb-6'>
                {service.subtitle}
              </p>
              <p className='text-lg text-white/75 leading-relaxed mb-8'>
                {service.description}
              </p>
              <Link to='/contact'>
                <Button
                  className='btn-gradient'
                  data-testid='dienst-contact-btn'>
                  Vraag Informatie Aan
                  <ArrowRight className='w-5 h-5 ml-2' />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className='py-20 bg-white'>
        <div className='max-w-[1400px] mx-auto px-6 lg:px-10'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-[#16224b] mb-4'>
              Voordelen
            </h2>
            <p className='text-lg text-[#6b7184]'>
              Wat {service.title} voor uw bedrijf kan betekenen
            </p>
          </div>

          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto'>
            {service.benefits.map((benefit, index) => (
              <div
                key={index}
                className='flex items-start gap-3 p-5 rounded-lg bg-[#f8f9fd] border border-gray-100'
                data-testid={`benefit-${index}`}>
                <CheckCircle className='w-6 h-6 text-[#3d56a6] flex-shrink-0 mt-0.5' />
                <span className='text-[#16224b]'>{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='py-20 bg-[#f8f9fd]'>
        <div className='max-w-[1400px] mx-auto px-6 lg:px-10'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-[#16224b] mb-4'>
              Wat wij bieden
            </h2>
          </div>

          <div className='grid md:grid-cols-2 gap-8'>
            {service.features.map((feature, index) => (
              <div
                key={index}
                className='p-8 rounded-lg bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-shadow duration-300'
                data-testid={`feature-${index}`}>
                <h3 className='text-xl font-semibold text-[#16224b] mb-3'>
                  {feature.title}
                </h3>
                <p className='text-[#6b7184] leading-7'>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='py-20 bg-white'>
        <div className='max-w-[1400px] mx-auto px-6 lg:px-10'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-[#16224b] mb-4'>
              Onze Aanpak
            </h2>
            <p className='text-lg text-[#6b7184]'>
              Hoe wij {service.title} implementeren
            </p>
          </div>

          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
            {service.process.map((step, index) => (
              <div
                key={index}
                className='relative p-6 rounded-lg bg-[#f8f9fd] border border-gray-100'
                data-testid={`process-step-${index}`}>
                <span className='absolute -top-3 -left-3 w-8 h-8 rounded-full bg-[#f2a100] text-white flex items-center justify-center font-bold text-sm shadow-lg'>
                  {index + 1}
                </span>
                <p className='text-[#16224b] pt-2'>{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='py-20 bg-[#233a80]'>
        <div className='max-w-4xl mx-auto px-6 lg:px-10 text-center'>
          <h2 className='text-3xl font-bold text-white mb-6'>
            Interesse in {service.title}?
          </h2>
          <p className='text-xl text-white/70 mb-8'>
            Neem contact met ons op voor een vrijblijvend gesprek over de
            mogelijkheden.
          </p>
          <div className='flex flex-wrap justify-center gap-4'>
            <Link to='/contact'>
              <Button
                className='btn-gradient text-lg px-8 py-6'
                data-testid='dienst-cta-contact'>
                Neem Contact Op
                <ArrowRight className='w-5 h-5 ml-2' />
              </Button>
            </Link>
            <Link to='/diensten'>
              <Button
                variant='outline'
                className='btn-outline-white text-lg px-8 py-6'
                data-testid='dienst-cta-other'>
                Bekijk Andere Diensten
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
